import styled, { css } from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';
import Image from '../../Image';

export type FeatureGridProps = {
  invertContent?: boolean;
} & StyledImageProps;

export const FeatureGrid = styled(Grid)<FeatureGridProps>`
  ${(props) => css`
    flex-direction: ${props.invertContentOnMobile ? 'column-reverse' : 'column'};

    ${mediaQuery.tabletPortrait`
      flex-direction: ${props.invertContent ? 'row-reverse' : 'row'};
    `}
  `};

  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};

    ${mediaQuery.desktop`
      margin-top: ${spacing(6)};
      margin-bottom: ${spacing(6)};
    `}
  }
`;

// These empty styles are used to add styling in the Motability theme
export const ImageGridItem = styled(GridItem)``;

// These empty styles are used to add styling in the Motability theme
export const TextGridItem = styled(GridItem)``;

type StyledImageProps = {
  invertContentOnMobile?: boolean;
};

export const StyledImage = styled(Image)<StyledImageProps>`
  margin-top: ${({ invertContentOnMobile }) =>
    invertContentOnMobile ? spacing(4) : '0'};

  ${mediaQuery.tabletPortrait`
    margin-top: 0;
  `}
`;
